export enum TipoCantidadPaginado {
    SMALL = 30,
    NORMAL = 100,
    BIG = 1000,
    VERY_BIG = 10000
}